import React from 'react';
import { IconProps } from '.';

const SvgPauseFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M14.333 20H19V4h-4.667M5 20h4.667V4H5v16Z' />
    </svg>
  );
};

export default SvgPauseFill;
